<article class="suggestion-card" [class.suggestion-card--completed]="suggestion.completed">
    <header class="suggestion-card__header">
        <div>
            <h5 class="suggestion-card__title-skill">{{skillName}}</h5>
            <h4 class="suggestion-card__title">{{ suggestion.title }}</h4>
        </div>
    </header>

    <p class="suggestion-card__detail" [innerHTML]="suggestion.detail | breakLines"></p>

    <footer class="suggestion-card__footer">

        <app-button variant="success" size="sm" (onClick)="openSuggestionCompletedModal()" [disabled]="suggestion.completed">
            {{suggestion.completed ? 'Completada' : 'Completar'}}
        </app-button>

    </footer>
</article>